
    import './styles.scoped.css';
    export default {
  "alert": "awsui_alert_mx3cw_1kx9t_93",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_1kx9t_1",
  "root": "awsui_root_mx3cw_1kx9t_119",
  "hidden": "awsui_hidden_mx3cw_1kx9t_135",
  "body": "awsui_body_mx3cw_1kx9t_161",
  "header": "awsui_header_mx3cw_1kx9t_167",
  "action": "awsui_action_mx3cw_1kx9t_171",
  "action-button": "awsui_action-button_mx3cw_1kx9t_176",
  "alert-focus-wrapper": "awsui_alert-focus-wrapper_mx3cw_1kx9t_180",
  "alert-mobile-block": "awsui_alert-mobile-block_mx3cw_1kx9t_206",
  "text": "awsui_text_mx3cw_1kx9t_211",
  "icon": "awsui_icon_mx3cw_1kx9t_215",
  "message": "awsui_message_mx3cw_1kx9t_218",
  "breakpoint-default": "awsui_breakpoint-default_mx3cw_1kx9t_223",
  "icon-size-medium": "awsui_icon-size-medium_mx3cw_1kx9t_229",
  "icon-size-big": "awsui_icon-size-big_mx3cw_1kx9t_232",
  "icon-size-normal": "awsui_icon-size-normal_mx3cw_1kx9t_235",
  "content": "awsui_content_mx3cw_1kx9t_245",
  "dismiss": "awsui_dismiss_mx3cw_1kx9t_249",
  "dismiss-button": "awsui_dismiss-button_mx3cw_1kx9t_255",
  "type-error": "awsui_type-error_mx3cw_1kx9t_263",
  "type-warning": "awsui_type-warning_mx3cw_1kx9t_271",
  "type-success": "awsui_type-success_mx3cw_1kx9t_279",
  "type-info": "awsui_type-info_mx3cw_1kx9t_287"
};
  